import React, { useState } from 'react';
import { FileWarning, Loader2 } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;
const field = 'w-full rounded-lg border border-white/10 bg-black/40 px-3 py-2 text-sm text-gray-200';
const EMPTY = { kypa_id: '', record_type: 'T1', occurred_on: '', evidence: '', note: '' };

export function BreachRecordAdminPanel() {
  const { token } = useAuth();
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async () => {
    setBusy(true); setMsg(null);
    const r = await fetch(`${API}/api/admin/kypa/breach-records`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ ...f, kypa_id: f.kypa_id.trim(), evidence: f.evidence.trim() }),
    });
    const body = await r.json();
    setBusy(false);
    if (!r.ok) return setMsg({ ok: false, text: typeof body.detail === 'string' ? body.detail : body.detail?.[0]?.msg || 'Check the fields and try again.' });
    setMsg({ ok: true, text: `Logged ${body.record_type} for ${body.kypa_id}.` });
    setF(EMPTY);
  };

  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5 space-y-3" data-testid="breach-record-admin-panel">
      <div className="flex items-center gap-2"><FileWarning className="w-4 h-4 text-red-300" /><h3 className="text-sm font-semibold text-gray-300">Log a KYPA breach record (public, permanent)</h3></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        <input placeholder="KYPA ID" value={f.kypa_id} onChange={set('kypa_id')} className={field} data-testid="breach-admin-kypa-id" />
        <select value={f.record_type} onChange={set('record_type')} className={field} data-testid="breach-admin-type">
          <option value="T1">T1 Payment-Without-Delivery</option>
          <option value="T2">T2 Bad Output Proof</option>
          <option value="T3">T3 Mid-Transaction Endpoint Failure</option>
        </select>
        <input type="date" value={f.occurred_on} onChange={set('occurred_on')} className={field} data-testid="breach-admin-date" />
      </div>
      <input placeholder="Evidence: 0x transaction hash or https:// link" value={f.evidence} onChange={set('evidence')} className={field} data-testid="breach-admin-evidence" />
      <input placeholder="Short public note (optional, 280 characters max)" maxLength={280} value={f.note} onChange={set('note')} className={field} data-testid="breach-admin-note" />
      <button type="button" onClick={submit} disabled={busy || !f.kypa_id || !f.occurred_on || !f.evidence} className="inline-flex items-center gap-2 rounded-full bg-red-500 hover:bg-red-600 disabled:opacity-40 px-4 py-2 text-xs font-semibold text-white" data-testid="breach-admin-submit">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileWarning className="w-3.5 h-3.5" />} Log breach record
      </button>
      {msg && <p className={`text-xs ${msg.ok ? 'text-emerald-300' : 'text-red-400'}`} data-testid="breach-admin-message">{msg.text}</p>}
    </div>
  );
}
